// deploymentData.ts
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import { DeploymentType } from '../dtos/deployment/saveDeploymentRequest'

/**
 * ! Note: These interfaces need to be removed in a future story since the design changed for deployments.
 */

/**
 * Device status information
 */
export interface DeviceStatus {
  type: number;
  message: string;
  timestamp: string;
}

/**
 * Device information including list of all statuses for that device
 */
export interface Device {
  id: string;
  name: string;
  type: number;
  statuses: DeviceStatus[];
}

/**
 * Site information including devices for a given site
 */
export interface Site {
  id: string;
  name: string;
  devices: Device[];
}

/**
 * User data for the deployment
 */
export interface User {
  id: string;
  name: string;
}

/**
 * Meta data about for a deployment approval
 */
export interface DeploymentApproval {
  user: User;
  approved: boolean;
  timestamp: string;
}

/**
 * The DeploymentType indicates the type of deployment is being scheduled.
 */
export enum DeploymentStatus {
  Active = 'Active',
  Saved = 'Saved',
  Completed = 'Completed',
}

/**
 * Deployment interface contains everything a site would need to know about a deployment.
 */
export interface Deployment {
  id: string;
  name: string;
  createdDate: string;
  createdBy: User;
  notes: string;
  rebootAfterDeployment: boolean;
  solutionSet: {
    id: string;
    name: string;
    products: { [ProductName: string]: string };
  };
  preInstall?: {
    reboot: boolean;
    file: string;
    fileType: string;
    fileLocation: string;
  };
  postInstall?: {
    reboot: boolean;
    file: string;
    fileType: string;
    fileLocation: string;
  };
  scheduledBy?: User;
  schedule?: {
    startDate: string;
    timeType: DeploymentType;
    minutesAfterEOD?: number;
    time?: string;
  };
  approval?: DeploymentApproval;
  sites?: Site[];
}
